import { AfterViewChecked, Component, Inject, OnInit } from '@angular/core';
import { FilterSidebarModel, FiltersModel, PaginationModel, ProductModel, SlideshowModel } from './shop.model';
import { ShopService } from './shop.service';
import { UIRouter } from '@uirouter/angular';
import { ToastService } from '../core/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { isArray } from 'util';
import { AppConfigService } from '../../app.config.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Component({
  selector   : 'app-shop',
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
  templateUrl: './shop.component.html'
})

export class ShopComponent implements OnInit, AfterViewChecked {
  public wlCountry: string;
  public products: ProductModel[]          = [];
  public filters: FiltersModel             = null;
  public pagination: PaginationModel       = null;
  public slideshow: SlideshowModel         = null;
  public filtersLoaded: boolean            = false;
  public productsLoaded: boolean           = false;
  public bProductsUpdate: boolean          = false;
  public emptyState: boolean               = false;
  public filterSidebar: FilterSidebarModel = new FilterSidebarModel();
  private bCanInitializeScripting: boolean = false;
  private timedRangeInput: any             = null;
  private timedTextInput: any              = null;
  private mobileBreakpoint: number         = 720;
  public isSmallScreen: boolean;

  constructor(
    protected router: UIRouter,
    private shopService: ShopService,
    private toastService: ToastService,
    private translate: TranslateService,
    private location: Location,
    @Inject('WINDOW') private window: any,
    public breakpointObserver: BreakpointObserver,
  ) {}

  public ngOnInit(): void {
    this.wlCountry = AppConfigService.getDomainSettings().country || null;

    this.breakpointObserver.observe(`(max-width: ${this.mobileBreakpoint - 1}px)`).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
    });

    this.getProducts();
    this.getSlideshow();

    if (this.window !== undefined && this.window.innerWidth && this.window.innerWidth < this.mobileBreakpoint) {
      this.closeAllFilters();
    }
  }

  private getSlideshow(): void {
    this.shopService.getSlideshow().subscribe((res) => {
      this.slideshow = res;
    });
  }

  private getProducts(): void {
    this.shopService.getProducts(this.router.stateService.params).subscribe((res) => {
      if (res) {
        this.products                = res.Results;
        this.filters                 = res.Form;
        this.pagination              = res.Pagination;
        this.filtersLoaded           = true;
        this.productsLoaded          = true;
        this.bCanInitializeScripting = true;

        if (res.Results && res.Results.length <= 0) {
          this.emptyState = true;
        }

        this.filters.Radius.Distance.value = (this.filters.Radius.Distance.value) ? this.filters.Radius.Distance.value : '50';
      } else {
        this.emptyState = true;
      }
    }, () => {
      this.toastService.error(this.translate.instant('generic.errors.generic-error'));
    });
  }

  private updateProducts(param: string): void {
    this.bProductsUpdate = true;
    this.shopService.updateProducts(param).subscribe((res) => {
      if (res) {
        this.products                = res.Results;
        this.filters                 = res.Form;
        this.pagination              = res.Pagination;
        this.bProductsUpdate         = false;

        if (res.Results && res.Results.length <= 0) {
          this.emptyState = true;
        } else {
          this.emptyState = false;
        }

        this.filters.Radius.Distance.value = (this.filters.Radius.Distance.value) ? this.filters.Radius.Distance.value : '50';
      } else {
        this.products = [];
        this.pagination = null;
        this.bProductsUpdate = false;
        this.emptyState = true;
      }
    }, () => {
      this.toastService.error(this.translate.instant('generic.errors.generic-error'));
    });
  }

  public scrollTo(id: string) {
    const el = document.getElementById(id);
    const menuHeight = 75;
    const margin = 40;
    window.scrollTo(0, el.offsetTop - (menuHeight + margin));
  }

  public updateResults(selection: any, value?: string): void {
    if (selection === 'pagina' || selection === 'sort' || selection === 'radius' || (selection && Object.keys(selection).length > 0 && ((selection.type !== 'TEXT' && value && value.length > 0) || selection.type === 'TEXT'))) {

      if (this.isSmallScreen === false) {
        window.scrollTo(0,0);
      } else {
        this.scrollTo('product-overview-list');
      }

      if (selection.selected && isArray(selection.selected)) {
        if (selection.selected.indexOf(value, 0) >= 0) {
          selection.selected.splice(selection.selected.indexOf(value, 0), 1);
        } else {
          selection.selected.push(value);
        }
      }

      const _params = new URLSearchParams();
      Object.keys(this.filters).forEach((key) => {
        if (this.filters[key].type === 'SORT' && this.filters[key].selected && this.filters[key].selected.length > 0) {
          if (this.filters[key].selected === 'new') {
            _params.delete(this.filters[key].name);
          } else {
            _params.set(this.filters[key].name, this.filters[key].selected);
          }
        } else if (this.filters[key].selected && this.filters[key].selected.length > 0) {
          _params.set(this.filters[key].name, this.filters[key].selected.join(','));
        } else if (this.filters[key].value && this.filters[key].value.length > 0) {
          _params.set(this.filters[key].name, this.filters[key].value);
        } else if (this.filters[key].type && this.filters[key].type === 'RADIUS' && this.filters.Radius.Zip.value && this.filters.Radius.Zip.value.length > 0) {
          _params.set(this.filters.Radius.Zip.name, this.filters.Radius.Zip.value);

          if (this.filters.Radius.Distance.value && this.filters.Radius.Distance.value.length > 0) {
            _params.set(this.filters.Radius.Distance.name, this.filters.Radius.Distance.value);
          }

        }
      });

      if (selection === 'pagina') {
        _params.append('pagina', (value !== '1') ? value : '');
      }

      this.location.go((_params.toString() !== '') ? '?' + _params : '');
      this.updateProducts(_params.toString());
    }
  }

  public textSearch(event: any): void {
    if (this.timedTextInput) {
      clearTimeout(this.timedTextInput);
      this.timedTextInput = null;
    }

    this.timedTextInput = setTimeout(() => {
      if (event.target.value.length > 5) { // min 6 chars postalcode
        this.updateResults('radius');
        this.timedTextInput = null;
      }
    }, 1000);
  }

  public changeRangeValue(event: any): void {
    this.filters.Radius.Distance.value = event.target.value;
  }

  public rangeSlider(event: any): void {

    if (this.timedRangeInput) {
      clearTimeout(this.timedRangeInput);
      this.timedRangeInput = null;
    }

    this.timedRangeInput = setTimeout(() => {
      // this.filters.Radius.Distance.value = event.target.value;

      this.updateResults('radius');
      this.timedRangeInput = null;
    }, 500);
  }

  public changeSorting(sortType: string): void {
    this.updateResults('sort', sortType);
  }

  public optionChecked(value: string, selected: string[]): boolean {
    if (value && typeof value === 'string' && value.length > 0 && selected && selected.length > 0 && selected.indexOf(value, 0) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  public resetTextSearch(): void {
    this.filters.Keyword.value = '';
    this.updateResults(this.filters.Keyword, this.filters.Keyword.value);
  }

  public resetFilters(): void {
    const _params = new URLSearchParams();

    this.location.go('');
    this.updateProducts(_params.toString());
  }

  public ngAfterViewChecked(): void {
    if (this.bCanInitializeScripting) {
      if (this.slideshow && this.slideshow.slides && this.slideshow.slides.length > 0) {
        this.window.slider.init();
      }
      this.bCanInitializeScripting = false;
    }
  }

  public watchWindowSize(event): void {
    let _windowWatcher = null;
    if (_windowWatcher) {
      clearTimeout(_windowWatcher);
      _windowWatcher = null;
    }

    _windowWatcher = setTimeout(() => {
      if (event !== undefined && event.currentTarget !== undefined) {
        if (event.currentTarget.innerWidth && event.currentTarget.innerWidth < this.mobileBreakpoint) {
          this.closeAllFilters();
        } else {
          this.filterSidebar.Type.opened = true;
          this.filterSidebar.Model.opened = true;
          this.filterSidebar.Color.opened = true;
        }
      }
      _windowWatcher = null;
    }, 500);
  }

  private closeAllFilters(): void {
    for (const _filter in this.filterSidebar) {
      if (this.filterSidebar.hasOwnProperty(_filter)) {
        if (this.filterSidebar[_filter].opened !== undefined) {
          this.filterSidebar[_filter].opened = false;
        }
        if (this.filterSidebar[_filter].showall !== undefined) {
          this.filterSidebar[_filter].showall = false;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shop/shop.component.ts